<template>
  <div
    class="card shadow-sm h-100 animate__animated animate__fadeIn animate__faster"
    style="min-height: 232px;">
    <div class="card-body">
      <div
        class="row"
        :data-bs-toggle="product.eclipse_data ? 'modal' : ''"
        :data-bs-target="product.eclipse_data ? '#dropshipDetail' : ''"
        style="cursor: pointer;"
        @click="setActiveProduct">
        <div
          ref="img"
          class="col-4 col-sm-12 text-center">
          <img
            v-if="visible"
            :src="product.image_url"
            class="img-fluid"
            style="height: 7em; object-fit: contain;"
            :onerror="imgError">
        </div>
        <div
          class="col-8 col-sm-12"
          style="line-height: 18px;">
          <div style="height: 55px; overflow: hidden;">
            {{ product.description }}
          </div>
          <div
            class="text-muted"
            style="font-size: 12px;">
            UPC: {{product.upc}}
          </div>
          <div
            v-if="product.eclipse_data"
            class="text-muted"
            style="font-size: 12px;">
            Case Quantity: {{caseQuantity}}{{ product.eclipse_data.uom }}
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4 col-sm-12 d-flex align-items-center">
          <div class="float-start">
            <ProductPrice
              :product="product"
              :dropship="true"/>
          </div>
        </div>
        <div class="col-8 col-sm-12">
          <div
            class="d-flex align-items-end"
            style="height: 4.5em;">
            <QtyForm
              class="w-100"
              :product="product"
              :dropship="true"
              :dropshipMfg="mfg"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { computed, onMounted, onUnmounted, ref } from 'vue';
  import ProductPrice from '../../../product/price/ProductPrice.vue';
  import QtyForm from '../../../product/QtyForm.vue';
  import comingSoon from '../../../../../../shared/comingSoon';
  import { caseQty } from '../../../../../../repositories/dropshipRepository'

  onMounted(()=>{
    observer.value = new IntersectionObserver(([entry])=>{
      if(entry && entry.isIntersecting){
        visible.value = true
        if(visible.value){
          observer.value.unobserve(entry.target);
        }
      }
    })
    observer.value.observe(img.value)
  })

  onUnmounted(()=>{
    if(observer.value){
      observer.value.disconnect()
    }
  })

  // Initialize
  const props = defineProps(['product', 'env', 'mfg'])
  const store = useStore()
  const observer = ref(null)
  const visible = ref(false)
  const img = ref(null)

  // Methods
  const setActiveProduct = ()=>{
    store.dispatch('setDropshipActiveProduct', props.product)
  }

  const imgError = (e)=>{
    comingSoon(e)
  }

  const caseQuantity = computed(()=>{
    return caseQty(props.product)
  })
</script>